import { GoogleMap, Polyline, Marker, useJsApiLoader } from '@react-google-maps/api';
import { MAP_API_KEY } from "../../../utils/constants";
import { Breadcrumb, Button, Spin } from "antd";
import { breadcrumbIcon } from 'svgs';
import {useHistory, useParams} from "react-router-dom";
import { useCallback } from 'react';

interface TripPolylineMapProps {
    coordinates: { lat: number; lng: number }[];
}


export default function TripPolylineMap({ coordinates }: TripPolylineMapProps) {

    const history = useHistory();
      const onClickBack = useCallback(() => {
            history.goBack();
        }, [history]);
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: MAP_API_KEY,
        libraries: []
    });

    if (loadError) return <div>Error loading map</div>;

    const mapContainerStyle = {
        width: "100%",
        height: "500px",
    };

    

    // Auto center map based on bounds
    const onLoad = (map: google.maps.Map) => {
        const bounds = new google.maps.LatLngBounds();
        coordinates.forEach((c) => bounds.extend(c));
        map.fitBounds(bounds);
    };

    if (!isLoaded) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px" }}>
                <Spin size="large" />
            </div>
        );
    }

    const startPoint = coordinates[0];
    const endPoint = coordinates[coordinates.length - 1];

    return (
        <div>
               <Breadcrumb className="" separator={breadcrumbIcon}>
                    <Breadcrumb.Item>
                        <Button type="link" className="batteries-link" onClick={onClickBack}>
                            Trips
                        </Button>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Details</Breadcrumb.Item>
                </Breadcrumb>
        <GoogleMap
            mapContainerStyle={mapContainerStyle}
            onLoad={onLoad}
        >
            {/* Start Marker (GREEN) */}
            <Marker
                position={startPoint}
                icon={{
                    url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                }}
            />

            {/* End Marker (RED) */}
            <Marker
                position={endPoint}
                icon={{
                    url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
                }}
            />

            {/* Polyline */}
            <Polyline
                path={coordinates}
                options={{
                    strokeColor: "#0000FF", // BLUE
                    strokeOpacity: 1,
                    strokeWeight: 4,
                }}
            />
        </GoogleMap>
        </div>
    );
}
